import { useCurrentUser, useToastProvider } from "@qualio/ui-components";
import { useCurrentProduct } from "../useCurrentProduct";
import { useMutation, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { designControlsApi } from "../../api/designControls";
import { ReviewRecord } from "@design-controls/types";

export const useCreateReview = () => {
  const { t } = useTranslation();
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();
  const { showToast } = useToastProvider();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (review: Partial<ReviewRecord>) =>
      designControlsApi.createReview(companyId, productId, review),
    onSuccess: async () => {
      showToast({
        title: t("reviews.notifications.createSuccess.title"),
        description: t("reviews.notifications.createSuccess.description"),
        status: "success",
        duration: 5000,
      });
      await queryClient.invalidateQueries([
        "REVIEW_LIST",
        companyId,
        productId,
      ]);
    },
    onError: () => {
      showToast({
        title: t("reviews.notifications.createError.title"),
        description: t("reviews.notifications.createError.description"),
        status: "error",
        duration: 5000,
      });
    },
  });
};
